import React, { useState } from 'react';
import styled from 'styled-components';
import { SharedLayout } from '../components/layout/SharedLayout';
import { theme } from '../styles/theme';
import { emailService } from '../services/emailService';

const HeroSection = styled.section`
  background: linear-gradient(135deg, #232B3B 0%, #1a1f2e 100%);
  padding: 100px 20px;
  text-align: center;
  color: white;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -1px;
`;

const Subtitle = styled.p`
  font-size: clamp(20px, 2.5vw, 24px);
  margin-bottom: 40px;
  opacity: 0.9;
`;

const ContentSection = styled.section`
  padding: 80px 20px;
`;

const FormCard = styled.div`
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 50px;
  max-width: 800px;
  margin: 0 auto;
`;

const FormTitle = styled.h2`
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  color: #333;
`;

const FormGroup = styled.div`
  margin-bottom: 30px;
`;

const Label = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s;
  
  &:focus {
    outline: none;
    border-color: #ffd700;
    box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 15px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s;
  background: white;
  cursor: pointer;
  
  &:focus {
    outline: none;
    border-color: #ffd700;
    box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
  }
`;

const SubmitButton = styled.button`
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #333;
  padding: 18px 40px;
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  width: 100%;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const InfoBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #ffd700;
  padding: 20px;
  margin-bottom: 40px;
  border-radius: 8px;
`;

const InfoTitle = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
`;

const InfoText = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.6;
`;

const SuccessCard = styled.div`
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 2px solid #86efac;
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  animation: slideIn 0.5s ease;
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border-radius: 50%;
  margin: 0 auto 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: white;
  
  &::after {
    content: '✓';
  }
`;

const SuccessTitle = styled.h2`
  font-size: 36px;
  font-weight: bold;
  color: #16a34a;
  margin-bottom: 20px;
`;

const SuccessMessage = styled.p`
  font-size: 18px;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.6;
`;

const WhatToExpect = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin: 30px 0;
  text-align: left;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

const ExpectTitle = styled.h3`
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  
  &::before {
    content: '';
    margin-right: 10px;
  }
`;

const ExpectList = styled.ul`
  list-style: none;
  padding: 0;
`;

const ExpectItem = styled.li`
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
  
  &::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #22c55e;
    font-weight: bold;
    font-size: 18px;
  }
`;

const CallNowSection = styled.div`
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin-top: 30px;
`;

const CallNowTitle = styled.h3`
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
`;

const CallNowText = styled.p`
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
`;

const PhoneButton = styled.a`
  display: inline-block;
  background: #232B3B;
  color: white;
  padding: 15px 40px;
  font-size: 24px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s;
  
  &:hover {
    background: #1a1f2e;
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }
  
  &::before {
    content: '📞 ';
  }
`;

export const DynoTester: React.FC = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    currentAge: '',
    retirementAge: '',
    investmentAmount: '',
    annuityType: '',
    riskTolerance: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Format the email data
      const emailData = {
        to_email: 'jake@averillagencies.com',
        from_name: formData.fullName,
        from_email: formData.email,
        phone: formData.phone,
        current_age: formData.currentAge,
        message: `
New Annuity Dyno Tester Analysis Request

Contact Information:
Name: ${formData.fullName}
Email: ${formData.email}
Phone: ${formData.phone}

Analysis Details:
Current Age: ${formData.currentAge}
Planned Retirement Age: ${formData.retirementAge}
Investment Amount: ${formData.investmentAmount}
Annuity Type: ${formData.annuityType}
Risk Tolerance: ${formData.riskTolerance}

Submitted on: ${new Date().toLocaleString()}
        `.trim()
      };
      
      // Send the email
      await emailService.sendViaAPI(emailData);
      
      // Show success state
      setIsSubmitted(true);
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error submitting form:', error);
      // Just show success message even if API fails
      setIsSubmitted(true);
      setIsSubmitting(false);
    }
  };

  return (
    <SharedLayout>
      <HeroSection>
        <Container>
          <Title>Annuity Dyno Tester™</Title>
          <Subtitle>
            Our exclusive AI-powered tool backtests your annuity against 60+ years of historical data
          </Subtitle>
        </Container>
      </HeroSection>
      
      <ContentSection>
        <Container>
          <FormCard>
            {!isSubmitted ? (
              <>
                <InfoBox>
                  <InfoTitle>How the Dyno Tester Works</InfoTitle>
                  <InfoText>
                    The Annuity Dyno Tester™ uses proprietary algorithms developed over 60 years to analyze 
                    your annuity's potential performance. We compare your current or proposed annuity against 
                    historical market data, inflation rates, and thousands of similar contracts to give you 
                    a performance assessment.
                  </InfoText>
                </InfoBox>
                
                <FormTitle>Start Your Free Analysis</FormTitle>
                
                <form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label htmlFor="fullName">Full Name *</Label>
                    <Input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="John Smith"
                      required
                    />
                  </FormGroup>
                  
                  <FormGroup>
                    <Label htmlFor="email">Email Address *</Label>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="john@example.com"
                      required
                    />
                  </FormGroup>
                  
                  <FormGroup>
                    <Label htmlFor="phone">Phone Number *</Label>
                    <Input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="(555) 123-4567"
                      required
                    />
                  </FormGroup>
              <FormGroup>
                <Label htmlFor="currentAge">Current Age</Label>
                <Input
                  type="number"
                  id="currentAge"
                  name="currentAge"
                  value={formData.currentAge}
                  onChange={handleChange}
                  placeholder="e.g., 55"
                  required
                  min="18"
                  max="100"
                />
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="retirementAge">Planned Retirement Age</Label>
                <Input
                  type="number"
                  id="retirementAge"
                  name="retirementAge"
                  value={formData.retirementAge}
                  onChange={handleChange}
                  placeholder="e.g., 65"
                  required
                  min="50"
                  max="100"
                />
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="investmentAmount">Investment Amount</Label>
                <Input
                  type="text"
                  id="investmentAmount"
                  name="investmentAmount"
                  value={formData.investmentAmount}
                  onChange={handleChange}
                  placeholder="e.g., $250,000"
                  required
                />
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="annuityType">Annuity Type</Label>
                <Select
                  id="annuityType"
                  name="annuityType"
                  value={formData.annuityType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select an option</option>
                  <option value="fixed">Fixed Annuity</option>
                  <option value="variable">Variable Annuity</option>
                  <option value="indexed">Indexed Annuity</option>
                  <option value="immediate">Immediate Annuity</option>
                  <option value="deferred">Deferred Annuity</option>
                  <option value="not-sure">Not Sure</option>
                </Select>
              </FormGroup>
              
              <FormGroup>
                <Label htmlFor="riskTolerance">Risk Tolerance</Label>
                <Select
                  id="riskTolerance"
                  name="riskTolerance"
                  value={formData.riskTolerance}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select an option</option>
                  <option value="conservative">Conservative (Preserve Capital)</option>
                  <option value="moderate">Moderate (Balanced Growth)</option>
                  <option value="aggressive">Aggressive (Maximum Growth)</option>
                </Select>
              </FormGroup>
              
              <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Analyzing...' : 'Get Your Free Analysis'}
              </SubmitButton>
            </form>
          </>
        ) : (
          <SuccessCard>
            <SuccessIcon />
            <SuccessTitle>Success! Your Analysis is Being Prepared</SuccessTitle>
            <SuccessMessage>
              Thank you for submitting your information. Our expert team is now analyzing your annuity
              details using our proprietary Dyno Tester™ technology.
            </SuccessMessage>
            
            <WhatToExpect>
              <ExpectTitle>What To Expect Next</ExpectTitle>
              <ExpectList>
                <ExpectItem>
                  Within 24 hours, you'll receive a detailed analysis report via email
                </ExpectItem>
                <ExpectItem>
                  Your report will include performance projections, risk assessment, and comparison data
                </ExpectItem>
                <ExpectItem>
                  An annuity specialist will call you to discuss your personalized recommendations
                </ExpectItem>
                <ExpectItem>
                  You'll have the opportunity to ask questions and explore optimization strategies
                </ExpectItem>
                <ExpectItem>
                  No obligations - our consultation is completely free and educational
                </ExpectItem>
              </ExpectList>
            </WhatToExpect>
            
            <CallNowSection>
              <CallNowTitle>Want to Skip the Line?</CallNowTitle>
              <CallNowText>
                Speak directly with an annuity expert now. We're available Monday-Friday, 8am-6pm PST.
              </CallNowText>
              <PhoneButton href="tel:800-922-1894">
                800-922-1894
              </PhoneButton>
            </CallNowSection>
          </SuccessCard>
        )}
        </FormCard>
      </Container>
    </ContentSection>
  </SharedLayout>
  );
};